export const SENTRY_IGNORE_ERRORS: (string | RegExp)[] = [
  // Generic API noise — anchored to bare HTTP status text only. Do NOT use loose
  // substring patterns here: /unauthorized/i or /not found/i would also swallow
  // real, actionable errors like "User profile not found" or "Channel not found".
  /^(401\s+)?Unauthorized\.?$/i,
  /^(403\s+)?Forbidden\.?$/i,
  /^(404\s+)?Not Found\.?$/i,

  // Sentry performance "issue" titles that surface as errors via captureConsole etc.
  /N\+1 API Call/i,
  /HTTP\/1\.1 Overhead/i,

  // iOS Safari IndexedDB races from Firebase Auth persistence (FZ-WEB-NEXTJS-3N)
  /Connection to Indexed Database server lost/i,
  /IDBDatabase/i,
  /IndexedDB/i,

  // Next.js 16 RSC: external/stale clients sending malformed Next-Router-State-Tree.
  // Server falls back to full document render — silent for users. Captured by
  // Sentry.captureRequestError in instrumentation.ts. See FZSPF-3552 / FZ-WEB-NEXTJS-KS.
  /router state header.*could not be parsed/i,

  // Cross-origin script errors with no actionable context
  'top.GLOBALS',
  /Script error/i,
  'Object Not Found Matching Id',

  // Benign browser layout-loop warnings
  /ResizeObserver loop limit/i,
  /ResizeObserver loop completed/i,
  /ResizeObserver loop/i,

  // Third-party / analytics noise
  /gtm/i,
  /google-analytics/i,
  /TrackerStorageType is not defined/i,
  /consentmanager/i,
  // Twitter/X pixel fired from the GTM container before its base tag defines
  // window.twq. Marketing analytics misfire — not actionable in-app and does
  // not affect checkout. Safari: "Can't find variable: twq"; Chrome/Firefox:
  // "twq is not defined". See issue 7369344618.
  /Can't find variable: twq/i,
  /twq is not defined/i,

  // Network failures the user retries naturally
  /Failed to fetch/i,
  /Load failed/i,
  /NetworkError/i,

  // Fetch/media/query cancellation — user navigation, unmount (FZ-WEB-NEXTJS-EZ, FZ-WEB-NEXTJS-EW)
  /AbortError/i,
  /^Aborted$/i,

  // Blocked storage in private browsing / WebViews (FZ-WEB-NEXTJS-FT)
  /SecurityError.*localStorage/i,
  /localStorage access denied/i,
  // iOS Safari private/locked-down mode throws DOMException 18 with the generic
  // message "The operation is insecure." when storage is blocked — e.g. paho-mqtt
  // reading global.localStorage at module init. No "localStorage" token in the
  // message, so the pattern above misses it. This DOMException message is always
  // a browser security-policy violation, not an app bug. See issue 7592951489.
  /The operation is insecure/i,

  // Blaze SDK init failure — transient API/network (FZ-WEB-NEXTJS-EY)
  /Error in getAppConfigurations/i,

  // Native iOS WebView bridge not registered (FZ-WEB-NEXTJS-K5)
  /WKWebView API client did not respond to postMessage/i,

  // Google IMA3 ad SDK <script> tag failing to load (ad blocker, network
  // restriction, or regional CDN block). Surfaces as an unhandled promise
  // rejection with the raw <script> tag as the reason (some ad-loading utility
  // rejects with `Failed to load element: ${el.outerHTML}` on the element's
  // `error` event). Not our code, not actionable — the ad slot simply doesn't
  // render, playback is unaffected. See FZ-WEB-NEXTJS-2P.
  /Failed to load element:.*imasdk\.googleapis\.com/i,
  // Same ad-blocking/network-restriction pattern as above, but for Google
  // Publisher Tag (GPT/DFP) instead of IMA3 — `securepubads.g.doubleclick.net`
  // is GPT's script host. An ad blocker or regional CDN block prevents the
  // <script> tag from loading; the ad slot just doesn't render, no impact on
  // playback. This was the single largest source of noise in FZ-WEB-NEXTJS-2P
  // (879 events / 112 users) — the imasdk-only pattern above never matched it
  // because it's a different ad SDK host. See FZ-WEB-NEXTJS-2P.
  /Failed to load element:.*securepubads\.g\.doubleclick\.net/i,
]
